import React from 'react';
import { Button } from '../../../../components/Button/Button';
import { ComposedMaps, markerIcons } from '../../../../components/Map/Map';
import { AddressParts } from '../../../../hooks/useDesktopGoogleApi';
import { useLanguage } from '../../../../locale/useLanguage';
import './VerifyMapPosition.css';

type VerifyMapPositionProps = {
  address: AddressParts;
  onContinue: () => void;
};

export const VerifyMapPosition: React.FC<VerifyMapPositionProps> = ({
  address,
  onContinue,
}) => {
  const [t] = useLanguage();
  const { street, streetNumber, aal3, aal2, zipCode } = address;

  return (
    <>
      <div className="verify-map-position--heading-container">
        <h2 className="verify-map-position--subtitle">
          {t('verifyMapPositionView.title')}
        </h2>
        <p className="verify-map-position--description">
          {t('verifyMapPositionView.description')}
        </p>
      </div>
      <ComposedMaps
        isGestureEnabled={false}
        zoom={14}
        centerMap={{ lat: address.lat, lng: address.lng }}
        markers={[
          {
            icon: markerIcons.location,
            lat: address.lat,
            lng: address.lng,
          },
        ]}
      />
      <div className="verify-map-position--address-container">
        <h2 className="verify-map-position--subtitle">
          {t('verifyMapPositionView.selectedAddress')}
        </h2>
        <p className="verify-map-position--description">
          {`${street}, ${streetNumber}, ${aal3}, ${aal2}, ${zipCode}`}
        </p>
      </div>
      <Button
        label={t('verifyMapPositionView.continue')}
        onClick={onContinue}
        isPrimary
      />
    </>
  );
};
